module.exports = __webpack_public_path__ + "img/edit_event_step4_off.9a72291e.png";